class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        const markup = this.getSectionInnerHTML(html, '.shopify-section');
        const target = document.getElementById('mini-cart');

        // Sem esta saida o drawer ficava so com o spinner girando para sempre.
        if (markup === null) {
          console.error('[cart-drawer] ' + this.dataset.url + ' nao retornou .shopify-section');
          if (target) target.innerHTML =
            '<div style="padding:3rem 2rem;text-align:center;font-size:1.4rem;line-height:1.6">' +
            '<p style="margin:0 0 1.6rem">Não foi possível carregar o carrinho aqui.</p>' +
            '<a href="/cart" class="button" style="display:inline-block">Ver meu carrinho</a>' +
            '</div>';
        } else if (target) {
          target.innerHTML = markup;
        }

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    if (!this.drawer) return;

    const detailsElement = this.drawer.querySelector('details');
    if (!detailsElement) return;

    // Enquanto o drawer fecha, o [open] continua no <details> por ~400ms ate o
    // closeAnimation remove-lo. Sair aqui nesse intervalo era o que deixava o
    // cliente sem feedback: o item entrava no carrinho e nada abria na tela.
    if (detailsElement.classList.contains('menu-closing')) {
      clearInterval(this.reopenTimer);
      let waited = 0;
      this.reopenTimer = setInterval(() => {
        waited += 50;
        if (detailsElement.classList.contains('menu-closing') && waited < 1000) return;

        clearInterval(this.reopenTimer);
        if (!detailsElement.hasAttribute('open')) this.drawer.openMenuDrawer();
      }, 50);
      return;
    }

    if (detailsElement.hasAttribute('open')) return;

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const target = document.getElementById(section.id);
      if (!target) return;

      // Se uma section vier ausente da resposta, o getSectionInnerHTML lancava
      // TypeError aqui: o forEach abortava, o open() abaixo nao rodava e a
      // excecao morria no .catch() do add-to-cart, que so faz console.error.
      const markup = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (markup !== null) target.innerHTML = markup;
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string') return null;

    const found = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return found ? found.innerHTML : null;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
